// extracted by css-extract-rspack-plugin
export default {"paragraph":"_71ae8e0a","inputContainer":"_7e949135","buttonContainer":"_d6caee15","spinnerContainer":"_ef33b01e","buttonContent":"_9bbb5c1b","connectButtons":"_ad8e84df"};